// extracted by mini-css-extract-plugin
export default {"preferenceCard":"preference-card_preferenceCard__CK6lR","cardText":"preference-card_cardText__1MWDh"};